import * as Types from '../constants/actionTypes';
const defaultState = {
    userRoles: [],
    allRoles: [],
    allRightsOfRole: []
}
export default (state=defaultState, action)=> {
    switch(action.type) {
        case Types.USER_ROLE_LIST:
            return {
                ...state,
                userRoles: action.userRoles
            }
        case Types.ALL_ROLES_DATA:
            return {
                ...state,
                allRoles: action.payload
            }
        case Types.RIGHTS_BY_ROLE_DATA:
            return {
                ...state,
                allRightsOfRole: action.rightsData
            }
        case Types.ROLES_ERROR:
            return {
                ...state,
                roleError: action.roleError
            }
        case Types.ADDED_USER_ROLE: 
            state.userRoles.push(action.addedUserRole)
            return {
                ...state
            }
        case Types.USER_ROLE_ERROR:
            return {
                ...state,
                userRoleError: action.userRoleError
            }
        case Types.DELETED_USER_ROLE:
            state.userRoles.splice(action.deleteIndex, 1)
            return { ...state}
        case Types.ADDED_ROLE:
            return {
                ...state,
                allRoles: [...state.allRoles, action.addedRole]
            }
        case Types.DELETED_ROLE_DATA:
            return {
                ...state,
                allRoles: [...state.allRoles.filter(item => item.id !== action.payload.id)]
            }
        
        case Types.UPDATED_ROLE:
            let changedRoleIndex = state.allRoles.findIndex(item => item.id === action.updatedRole.id);
            if (changedRoleIndex > -1) {
                state.allRoles[changedRoleIndex] = action.updatedRole;
            }
            return {
                ...state
            }
            case Types.ROLES_INFO_COUNT_SUCCESS:
              return Object.assign({}, state, { rolesInfoCount: action.payload})
        
        default: 
            return state
    }
}